import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Home() {
  return (<>
    <Helmet>
      <title>ApnaWebX – Professional Website Development, Branding & Digital Solutions</title>
      <meta name="description" content="ApnaWebX delivers high-quality website development, portfolio websites, branding, SEO, WhatsApp automation, and complete digital solutions for businesses across India." />
      <meta name="keywords" content="website development company, web design Ahmedabad, portfolio website, business website builder, digital marketing, branding services" />

      <link rel="canonical" href="https://apnawebx.com/" />

      {/* Open Graph */}
      <meta property="og:title" content="ApnaWebX – Professional Website Development & Digital Solutions" />
      <meta property="og:description" content="We provide modern websites, branding, SEO, WhatsApp automation & IT solutions." />
      <meta property="og:image" content="https://apnawebx.com/images/og-image-home.jpg" />
      <meta property="og:url" content="https://apnawebx.com/" />
      <meta property="og:type" content="website" />


      <script type="application/ld+json">
        {`  {
          "@context": "https://schema.org",
        "@type": "Organization",
        "name": "ApnaWebX",
        "url": "https://apnawebx.com",
        "logo": "https://apnawebx.com/images/logo/apnawebxlogo.png",
        "description": "We provide website development, branding, SEO, WhatsApp automation & digital services.",
        "address": {
          "@type": "PostalAddress",
        "addressLocality": "Ahmedabad",
        "addressRegion": "Gujarat",
        "addressCountry": "IN"
  },
        "sameAs": [
        "https://www.instagram.com/apnawebx",
        "https://www.facebook.com/apnawebx"
        ]
}
        `}
      </script>

    </Helmet>

    <div className="overflow-hidden">



      {/* ===================== NEW HERO SECTION ===================== */}
      <section className="relative overflow-hidden bg-white pt-32 pb-16">

        {/* Background abstract shapes */}
        <div className="absolute top-0 left-0 w-[550px] h-[550px] bg-[#855109]/10 rounded-full blur-3xl -translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#d4a257]/20 rounded-full blur-3xl translate-x-1/4 translate-y-1/4"></div>

        <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-20 items-center">

          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-7"
          >
            {/* Badge */}
            <div className="inline-block px-5 py-2 bg-[#855109]/10 text-[#855109] rounded-full font-semibold text-sm shadow-sm border border-[#855109]/20">
              Transforming Brands with Technology
            </div>

            {/* Heading */}
            <h1 className="text-4xl md:text-5xl font-montserrat font-extrabold leading-tight text-[#2b1b0a]">
              We Build Websites That Help
              <span className="text-[#855109]"> Your Business Grow Faster</span>
            </h1>

            {/* Subtext */}
            <p className="text-lg text-gray-700 font-vollkorn max-w-lg leading-relaxed">
              Professional website development, branding, SEO, and digital solutions for startups, small businesses, and established brands.
            </p>

            {/* Buttons */}
            <div className="flex  gap-2 mt-4">
              <Link
                to="/contact"
                className="px-6 pt-3 pb-2 bg-[#855109] text-white font-montserrat rounded-xl shadow-md hover:bg-[#6b4108] transition duration-300"
              >
                Start a Project
              </Link>

              <Link
                to="/portfolio"
                className="px-6 pt-3 pb-2 border-2 border-[#855109] text-[#855109] rounded-xl hover:bg-[#855109] hover:text-white transition duration-300"
              >
                Explore Work
              </Link>
            </div>


          </motion.div>

          {/* RIGHT SIDE — FLOATING CARDS */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="relative z-10"
          >
            {/* Floating Cards */}
            <div className="absolute z-10 -top-10 left-2 md:left-10 bg-white shadow-xl rounded-2xl p-2 pl-5 md:p-6 w-56 border border-[#855109]">
              <span className="block font-montserrat font-bold text-xl text-[#855109]">
                Website
              </span>
              <p className="text-gray-600 text-sm font-vollkorn">
                Custom, fast & lead focused
              </p>
            </div>

            <div className="absolute z-10 bottom-12 md:bottom-5 -right-5 md:-right-10 bg-white shadow-xl rounded-2xl p-2 pl-5 md:p-6 w-56 border border-[#855109]">
              <span className="block font-montserrat font-bold text-xl text-[#855109]">
                Automation
              </span>
              <p className="text-gray-600 text-sm font-vollkorn">
                WhatsApp, CRM, Bulk Chat
              </p>
            </div>

            <div className="absolute z-10 -bottom-10 md:-bottom-16 -left-5 bg-white shadow-xl rounded-2xl p-2 pl-5 md:p-6 w-56 border border-[#855109]">
              <span className="block font-montserrat font-bold text-xl text-[#855109]">
                Marketing
              </span>
              <p className="text-gray-600 text-sm font-vollkorn">
                Ads, Branding & Growth
              </p>
            </div>


            {/* Main Image */}
            {/* <img
              src="/images/home/hero-home.jpg"
              alt="ApnaWebX"
              loading="lazy"
              className="relative rounded-[2rem] shadow-2xl border border-gray-200"
            /> */}
            {/* Main Image */}
            <img
              src="/images/home/hero-home.jpg"
              alt="ApnaWebX homepage hero image"
              loading="lazy"
              width="1200"
              height="1000"
              className="relative rounded-[2rem] shadow-2xl border border-gray-200"
            />

          </motion.div>

        </div>
      </section>







      {/* ===================== ABOUT US SECTION ===================== */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

          {/* LEFT IMAGE GLASS BOX */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="bg-white/20 backdrop-blur-xl shadow-2xl border border-gray-200 rounded-2xl overflow-hidden">
              <img src="/images/home/about-sec.jpg" loading="lazy" alt="ApnaWebX" className="h-[350px] md:h-[600px] w-full object-cover " />
            </div>
          </motion.div>

          {/* RIGHT TEXT SIDE */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl font-extrabold text-[#855109] mb-4">
              About ApnaWebX
            </h2>

            <p className="text-gray-700 leading-relaxed text-lg ">
              ApnaWebX is a professional IT solutions agency specializing in website development, branding, SEO, digital marketing, and WhatsApp automation.
              Our mission is to help businesses grow with high-quality websites and impactful digital strategies.
            </p>

            <p className="text-gray-700 leading-relaxed text-lg mt-4 ">
              Our mission is to empower businesses with clean design, powerful
              technology, and result-driven strategies. We believe in building digital
              experiences that help brands grow, perform, and stand out in the
              competitive market.
            </p>

            {/* SMALL FEATURES */}
            <div className="grid grid-cols-2 gap-4 my-6 ">

              <div className="bg-gray-50 border border-gray-200 shadow-sm p-4 rounded-xl flex flex-col">
                <span className="text-[#855109] font-bold text-xl">5+</span>
                <span className="text-gray-600 text-sm ">Years Experience</span>
              </div>

              <div className="bg-gray-50 border border-gray-200 shadow-sm p-4 rounded-xl flex flex-col">
                <span className="text-[#855109] font-bold text-xl">150+</span>
                <span className="text-gray-600 text-sm ">Projects Completed</span>
              </div>

              <div className="bg-gray-50 border border-gray-200 shadow-sm p-4 rounded-xl flex flex-col">
                <span className="text-[#855109] font-bold text-xl">100%</span>
                <span className="text-gray-600 text-sm ">Client Satisfaction</span>
              </div>

              <div className="bg-gray-50 border border-gray-200 shadow-sm p-4 rounded-xl flex flex-col">
                <span className="text-[#855109] font-bold text-xl">24/7</span>
                <span className="text-gray-600 text-sm ">Support Available</span>
              </div>

            </div>

            {/* CTA BUTTON */}
            <motion.div
              whileHover={{ y: -6 }}>
              <Link to="/about" className="mt-8 px-8 py-3 bg-[#855109] text-white font-bold rounded-lg shadow hover:bg-[#6d4108] transition-all">Learn more about ApnaWebX</Link>

            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* MISSION & VISION */}
      <div className="mb-20 grid md:grid-cols-2 gap-14 px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-[#fff7ef] p-10 rounded-2xl border border-[#eed7bc] shadow-lg">
          <h2 className="text-3xl font-bold text-[#855109]">Our Mission</h2>
          <p className="mt-4 text-gray-700 leading-relaxed">
            To make digital transformation affordable and accessible for every business by delivering innovative, reliable, and result-oriented IT solutions.

          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }} className="bg-[#fff7ef] p-10 rounded-2xl border border-[#eed7bc] shadow-lg">
          <h2 className="text-3xl font-bold text-[#855109]">Our Vision</h2>
          <p className="mt-4 text-gray-700 leading-relaxed">
            To become a leading digital solutions provider known for creativity, quality, and customer satisfaction.
          </p>
        </motion.div>
      </div>


      {/* ===================== SERVICES — DIAGONAL SPLIT DESIGN ===================== */}
      <section className="relative py-20 overflow-hidden bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/images/home/service-bg.jpg')" }}>

        {/* DIAGONAL BACKGROUND */}
        <div className="absolute inset-0 z-10 bg-[#0b0a09]/70    -skew-y-4 origin-top-left"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">

          {/* Heading */}
          <div className="text-center mb-20">
            <h2 className="text-4xl mb-10 md:text-5xl font-montserrat font-extrabold text-[#d4a257]">
              Our Core Services
            </h2>
            <p className="text-gray-300 font-vollkorn mt-3 max-w-2xl mx-auto text-xl">
              High-quality digital solutions crafted for business growth and performance.
            </p>
          </div>

          {/* DIAGONAL GRID */}
          <div className="grid gap-3">

            {/* ROW 1 */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-10">

              <motion.div
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                className="bg-[#1a140c] p-8 w-full md:w-[48%] rounded-2xl border border-[#d4a257]/20 shadow-lg hover:scale-[1.03] transition duration-300"
              >
                <h3 className="text-2xl font-bold text-[#d4a257]">Website & App Development </h3>
                <p className="text-gray-300 font-vollkorn mt-2">
                  We build responsive, SEO-friendly, modern websites tailored for your business.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                className="bg-[#1a140c] p-8 w-full md:w-[48%] rounded-2xl border border-[#d4a257]/20 shadow-lg hover:scale-[1.03] transition duration-300"
              >
                <h3 className="text-2xl font-bold text-[#d4a257]">  Branding & Design</h3>
                <p className="text-gray-300 font-vollkorn mt-2">
                  Build a strong brand identity with logos, color schemes, typography, and complete brand design.
                </p>
              </motion.div>
            </div>

            {/* ROW 2 (INVERTED ALIGNMENT) */}
            <div className="flex flex-col md:flex-row-reverse items-center justify-between gap-10 mt-10">

              <motion.div
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                className="bg-[#1a140c] p-8 w-full md:w-[48%] rounded-2xl border border-[#d4a257]/20 shadow-lg hover:scale-[1.03] transition duration-300"
              >
                <h3 className="text-2xl font-bold text-[#d4a257]">  Digital Marketing</h3>
                <p className="text-gray-300 font-vollkorn mt-2">
                  Grow your business with targeted ads, SEO, social media marketing & performance campaigns.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                className="bg-[#1a140c] p-8 w-full md:w-[48%] rounded-2xl border border-[#d4a257]/20 shadow-lg hover:scale-[1.03] transition duration-300"
              >
                <h3 className="text-2xl font-bold text-[#d4a257]">WhatsApp Automation</h3>
                <p className="text-gray-300 font-vollkorn mt-2">
                  Automate replies, send bulk messages, manage leads, and improve customer engagement.
                </p>
              </motion.div>
            </div>

          </div>

        </div>
      </section>





      {/* ===================== WHY CHOOSE US — FLOW TIMELINE DESIGN ===================== */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl font-extrabold font-montserrat text-[#855109] text-center">
            Why Choose ApnaWebX for Your Website?
          </h2>
          <p className="text-center text-gray-600 font-vollkorn mt-3 mb-16 max-w-2xl mx-auto">
            We help businesses build a strong digital presence using modern design, smart technology, and results-driven digital strategies.
          </p>

          <div className="relative">

            {/* Vertical Line */}
            <div className="absolute left-6 md:left-1/2 top-0 h-full w-[3px] bg-[#855109]/20"></div>

            {/* ITEM 1 */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className="relative flex md:justify-end md:text-right mb-20"
            >
              <div className="w-10 h-10 bg-[#855109] text-white rounded-full flex items-center justify-center font-bold
                        absolute left-0 md:left-1/2 transform md:-translate-x-1/2 -translate-y-1/2 shadow-lg">
                1
              </div>

              <div className="bg-[#f9f5ef] p-8 rounded-2xl shadow-md w-full md:w-[45%]">
                <h3 className="text-2xl font-bold text-[#855109] mb-2">High-quality professional designs</h3>
                <p className="text-gray-600 text-sm font-vollkorn">
                  Experience premium UI/UX, responsive layouts, smooth performance, and modern coding standards.
                </p>
              </div>
            </motion.div>

            {/* ITEM 2 */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className="relative flex md:justify-start md:text-left mb-20"
            >
              <div className="w-10 h-10 bg-[#855109] text-white rounded-full flex items-center
         justify-center font-bold
                        absolute left-0 md:left-1/2 transform md:-translate-x-1/2 -translate-y-1/2 shadow-lg">
                2
              </div>

              <div className="bg-[#f9f5ef] p-8 rounded-2xl shadow-md w-full md:w-[45%] md:mr-[55%]">
                <h3 className="text-2xl font-bold text-[#855109] mb-2">Fast-loading, SEO-friendly websites</h3>
                <p className="text-gray-600 text-sm font-vollkorn">
                  Strict delivery timelines ensuring your project launches faster without quality compromise.
                </p>
              </div>
            </motion.div>

            {/* ITEM 3 */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className="relative flex md:justify-end md:text-right"
            >
              <div className="w-10 h-10 bg-[#855109] text-white rounded-full flex items-center justify-center font-bold
                        absolute left-0 md:left-1/2 transform md:-translate-x-1/2 -translate-y-1/2 shadow-lg">
                3
              </div>

              <div className="bg-[#f9f5ef] p-8 rounded-2xl shadow-md w-full md:w-[45%]">
                <h3 className="text-2xl font-bold text-[#855109] mb-2">Branding and digital growth services</h3>
                <p className="text-gray-600 text-sm font-vollkorn">
                  Build a strong brand identity with logos, color schemes, typography, and complete brand design.
                </p>
              </div>
            </motion.div>

          </div>
        </div>
      </section>




      {/* ===================== CTA SECTION (SPLIT LAYOUT) ===================== */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 items-center gap-12">

          {/* Image */}
          <img
            src="/images/home/cta-bg.png"
            className="rounded-2xl shadow-xl"
            loading="lazy"
            alt="ApnaWebX"
          />

          {/* Text */}
          <div className="space-y-6">
            <h2 className="text-4xl font-montserrat font-bold text-[#855109] leading-tight">
              Ready to Build Your Website?
            </h2>

            <p className="text-gray-600 text-lg font-vollkorn">
              Get a free consultation and start your digital growth journey today.
            </p>

            <Link
              to="/contact"
              className="inline-block mt-3 px-10 py-4 bg-[#855109] text-white font-montserrat font-bold rounded-lg shadow-lg hover:bg-[#6d4108] transition"
            >
              Get in Touch
            </Link>
          </div>

        </div>
      </section>


    </div>
  </>);
}
